<template></template>

<script>
  import 'jquery-validation'
  import 'select2/dist/js/select2.min.js'
  
  export default {
    name: 'RegisterThesisDirection',
    mounted() {
      /**
       * Init Select2 for countries
       */
      const countries = $('.search-country')
      
      countries.select2({
        language: {
          noResults: function() {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })
      
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $(document).ready(function() {
          $('.form').validate({
            ignore: [],
            highlight: function(element, errorClass, validClass) {
              $(element).addClass('is-invalid')
            },
            unhighlight: function(element, errorClass, validClass) {
              $(element).removeClass('is-invalid')
            },
            errorPlacement: function(label, element) {
              if(element.hasClass('select2-input')) {
                label.insertAfter(element.siblings('span.select2'))
              } else if(element.is(':radio')) {
                label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
              }
              else {
                label.insertAfter(element)
              }
              
              label.addClass('invalid-feedback')
            },
            rules: {
              work_type_id: {
                required: true,
              },
              work_title: {
                required: true,
              },
              country_id: {
                required: true,
              },
              language_id: {
                required: true,
              },
              generation: {
                
              },
              end_year: {
                required: true,
              },
              participation: {
                required: true,
              },
              name: {
                required: true,
              },
              institution: {
                required: true,
              },
              program: {
                
              },
              has_scholarship: {
                required: true,
              },
              has_financing: {
                required: function () {
                  return parseInt($(':radio[name="has_scholarship"]:checked').val()) === 1
                },
              },
              financing_details: {
                required: function () {
                  return parseInt($(':radio[name="has_financing"]:checked').val()) === 1
                },
              },
              has_prizes: {
                required: true,
              },
              prizes_details: {
                required: function () {
                  return parseInt($(':radio[name="has_prizes"]:checked').val()) === 1
                },
              },
              comments: {
                
              },
              has_degree: {
                required: true,
              },
              year_of_degree: {
                required: function () {
                  return parseInt($(':radio[name="has_degree"]:checked').val()) === 1
                },
              },
            },
            messages: {
              work_type_id: {
                required: 'Este campo es requerido.',
              },
              work_title: {
                required: 'Este campo es requerido.',
              },
              country_id: {
                required: 'Este campo es requerido.',
              },
              language_id: {
                required: 'Este campo es requerido.',
              },
              generation: {
                required: 'Este campo es requerido.',
              },
              end_year: {
                required: 'Este campo es requerido.',
              },
              participation: {
                required: 'Este campo es requerido.',
              },
              name: {
                required: 'Este campo es requerido.',
              },
              institution: {
                required: 'Este campo es requerido.',
              },
              program: {
                required: 'Este campo es requerido.',
              },
              has_scholarship: {
                required: 'Este campo es requerido.',
              },
              has_financing: {
                required: 'Este campo es requerido.',
              },
              financing_details: {
                required: 'Este campo es requerido.',
              },
              has_prizes: {
                required: 'Este campo es requerido.',
              },
              prizes_details: {
                required: 'Este campo es requerido.',
              },
              comments: {
                required: 'Este campo es requerido.',
              },
              has_degree: {
                required: 'Este campo es requerido.',
              },
              year_of_degree: {
                required: 'Este campo es requerido.',
              },
            },
            submitHandler(form) {
              form.submit()
            },
          })
        })

        /**
         * Show collapsed inputs
         */
        showInputs()
        
        $(window).on('pageshow', function() {
          showInputs()
        })
        
        function showInputs() {
          $('.show-collapse:checked').each(function(key, input) {
            let target = $($(this).attr('data-target').replace(':not(.show)', ''))
            target.addClass('show')
          })
        }
      })
    },
  }
</script>
